<script setup>
import CMSCalls from '@core/api/modules/CMSCalls'
import { StrapiBlocks } from 'vue-strapi-blocks-renderer'

definePage({
  meta: {
    layout: 'default',

    // authenticatedOnly: true,
  },
})

onMounted(async () => {
  const response = await CMSCalls.fetchSinglePage('legal-disclosure?populate=*')

  item.value = response.data
})

const item = ref(null)
</script>

<template>
  <div
    v-if="item"
    class="detail-container"
  >
    <h1 class="detail-title">
      {{ item.title }}
    </h1>
    <div
      v-if="item.page_text"
      class="ckeditor-content"
      v-html="item.page_text"
    />
  </div>
</template>


<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Title Styling */
.title {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 20px;
}

/* Intro Section */
.intro-section {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
}

.intro-text {
  flex: 1;
  font-size: 1.2rem;
  line-height: 1.6;
}

.intro-image {
  flex: 1;
  max-width: 50%;
  height: auto;
  border-radius: 10px;
}

/* Content Blocks */
.content-blocks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30%, 1fr));
  gap: 20px;
}

.block {
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.block h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.block p {
  font-size: 1rem;
  line-height: 1.5;
}
</style>
